import { ParamsAlgolia } from "@services/algolia/types/paramsAlgolia.types";
import { AlgoliaRecommendationsQuery } from "@services/algolia/types/search.types";

const createFrequentlyBoughtTogetherQueries = (
    objectIDs: Array<string>,
    paramsAlgolia: ParamsAlgolia,
): Array<AlgoliaRecommendationsQuery> =>
    objectIDs.map(objectID => ({
        model: "bought-together",
        indexName: paramsAlgolia.indexName,
        objectID: objectID,
        maxRecommendations: paramsAlgolia.maxRecommendations,
        threshold: paramsAlgolia.threshold,
    }));

export { createFrequentlyBoughtTogetherQueries };
